import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
var withTranslation = function withTranslation(Component) {
  var Translated = /*#__PURE__*/function (_React$Component) {
    function Translated() {
      _classCallCheck(this, Translated);
      return _callSuper(this, Translated, arguments);
    }
    _inherits(Translated, _React$Component);
    return _createClass(Translated, [{
      key: "translateIfNeeded",
      value: function translateIfNeeded(key) {
        if (!key || !this.context || !this.context.translateFromContext) {
          return key;
        }
        return this.props.shouldTranslate ? this.context.translateFromContext(key) : key;
      }
    }, {
      key: "render",
      value: function render() {
        var props = _.assign({}, this.props, {
          translateIfNeeded: this.translateIfNeeded.bind(this)
        });
        return /*#__PURE__*/React.createElement(Component, props);
      }
    }]);
  }(React.Component);
  Translated.contextTypes = {
    translateFromContext: PropTypes.func
  };
  Translated.propTypes = {
    shouldTranslate: PropTypes.bool
  };
  Translated.defaultProps = {
    shouldTranslate: true
  };
  Translated.displayName = Component.displayName;
  return Translated;
};
export default withTranslation;